const AudioMap = require('AudioMap');
const { convertToGameCanvasHeight } = require('../../game-core/Generic/PSUtils');

const State = cc.Enum({
    NONE: 'none',
    IDLE: 'idle',
    IMPACT: 'impact',
    REMOVE: 'remove',
    MATCH: 'match',
    WIN_ANTICIPATION: 'winAnticipation',
    THUNDER: 'thunder',
    WILD_IMPACT: 'wildimpact',
    OVERRIDE: 'override',
    BLUR: 'blur'
});

const BlockData = cc.Class({
    name: 'BlockData',
    properties: {
        name: '', // just for visual recognition, not a functional
        skeleton: sp.SkeletonData,
        blurredFrame: cc.SpriteFrame
    }
});

cc.Class({
    extends: cc.Component,

    properties: {
        skeleton: sp.Skeleton,
        explodeSkeleton: sp.Skeleton,
        blurredSprite: cc.Sprite,
        assetsPerType: [BlockData],
        multiplierSpine: sp.Skeleton,
    },

    onLoad () {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.explodeSkeleton.setCompleteListener(() => {
            this.explodeSkeleton.node.active = false;
        });
    },

    start () {
        this.skeleton.setCompleteListener(() => {
            switch(this.skeleton.animation) {
                case 'lightning':
                    // this.stopThunder();
                    break;
                case 'match1':
                    if (this.isWild && this.isSpecial) {
                        this.skeleton.setAnimation(0, 'idle3', true);
                    } else if (this.hasFire) {
                        this.skeleton.setAnimation(0, 'idle2', true);
                    } else {
                        this.skeleton.setAnimation(0, 'idle1', true);
                    }
                    break;
                case 'match2':
                    if (this.isWild && this.isSpecial) {
                        this.skeleton.setAnimation(0, 'idle3', true);
                    } else {
                        this.skeleton.setAnimation(0, 'idle2', true);
                    }
                    break;
                case 'idle3':
                    this.audioMap.playSfx('specialWildSingleElectricAnimation');
                    break;
                case 'impact':
                    this._changeState(State.IDLE);

            }
        });
    },

    getTypeName () {
        return this.typeName;
    },

    setType (type) {
        this.isSpecial = type.includes('SP');
        this.isHited = false;
        this.multiplierNumber = Number.parseInt(type[type.length - 1]);
        if (isNaN(this.multiplierNumber) || type.length === 2) {
            this.multiplierNumber = 0;
        }
        this.hasFire = false;
        type = type.substr(0, 2);
        this.isWild = type === 'WI';
        this.node.opacity = 255;
        this.isCollected = false;
        this.isFreespins = false;
        this.state = State.NONE;
        // this.skeleton.node.setPosition(0, 0);
        if (typeof type === 'undefined') {
            cc.error('Block\'s type can not be undefined!' + type);
        }
        this.typeName = type;

        const data = this.assetsPerType.find((asset) => {
            return asset.name === this.typeName;
        });

        if (typeof data === 'undefined') {
            cc.error('Current type of block is not defined' + type);
        }

        this.skeleton.skeletonData = data.skeleton;
        this.blurredSprite.spriteFrame = data.blurredFrame;

        if (this.isWild) {
            const skin = this.isSpecial ? 'gold': 'normal'
            this.skeleton.setSkin(skin);

            this.skeleton.setMix('flash', 'anti1', 0.2);
            this.skeleton.setMix('flash', 'anti2', 0.2);
        }
    },

    getWorldCoord () {
        // const world = this.node.convertToWorldSpaceAR(this.node.position);
        return this.node.parent.convertToWorldSpaceAR(this.node.position);
    },

    getHeight () {
        return this.node.height;
    },

    playThunder () {
        this.isHited = true;
        this._changeState(State.THUNDER);
    },

    stopThunder () {
        this.skeleton.timeScale = 1;
        this.skeleton.setSkin('normal');
        this.skeleton.setAnimation(0, 'idle1', true);
        this.isSpecial = false;
    },

    getType () {
        return this.typeName;
    },

    /**
     * Built in function for Node.pool
     * This function is called when we PUT this node to pool
     */
    unuse () {
        this.state = State.NONE;
        this.node.active = false;
        this.typeName = null;
    },

    /**
     * Built in function for Node.pool
     * This function is called when we PULL this node from pool
     */
    reuse () {
        this.node.opacity = 255;
        this.node.active = true;
        this.skeleton.node.active = true;
    },

    playAnticipationGlow () {
        if (this.state !== State.THUNDER) {
            this._changeState(State.WIN_ANTICIPATION);
        }
    },

    match () {
        this._changeState(State.MATCH);
    },

    impact () {
        this._changeState(State.IMPACT);
    },

    setBlur () {
        this._changeState(State.BLUR);
    },

    overrideToWild (redCount, index) {
        const anim = index <= redCount? 'splash2': 'splash1';
        this.explodeSkeleton.node.active = true;
        this.explodeSkeleton.setAnimation(0, anim, false);

        cc.tween(this.node).
        // to(.1, { scale: 0 }, { easing: 'sineIn' }).
        delay(0.2).
        call(() => {
            this.setType('WI_SP');
            this.isHited = true;
            this.idle();
            this.node.scale = 1;
        }).
        // to(.2, { scale: 1 }, { easing: 'sineOut' }).
        start();
    },

    hide () {
        return new Promise((resolve) => {
            this.node.active = false;
            resolve();
        });
    },

    idle () {
        this._changeState(State.IDLE);
    },

    playWildImpact () {
        this._changeState(State.WILD_IMPACT);
    },

    hideSpecialWild () {
        this.skeleton.node.active = false;
    },

    _changeState (state) {
        if (this.state === state) {
            return;
        }
        switch (state) {
            case State.IDLE:
                this.node.active = true;
                this.blurredSprite.node.active = false;
                this.skeleton.node.active = true;
                if (this.hasFire) {
                    this.skeleton.setAnimation(0, 'anti2', true);
                } else if (this.isWild && this.isSpecial) {
                    this.skeleton.setAnimation(0, 'idle3', true);
                } else {
                    this.skeleton.setAnimation(0, 'idle1', true);
                }

                break;
            case State.IMPACT:
                this.skeleton.setAnimation(0, 'impact', false);
                break;
            case State.WIN_ANTICIPATION:
                this.node.active = true;
                this.blurredSprite.node.active = false;
                this.skeleton.node.active = true;
                this.hasFire = Boolean(this.multiplierNumber);
                const anim = this.hasFire ? 'anti2' : 'anti1';
                // if (this.state === State.WILD_IMPACT) {
                //     this.skeleton.addAnimation(0, anim, true);
                // } else {
                // }
                this.skeleton.setAnimation(0, anim, true);
                break;
            case State.WILD_IMPACT:
                this.skeleton.setAnimation(0, 'flash', false);
                break;
            case State.BLUR:
                this.blurredSprite.node.active = true;
                this.skeleton.node.active = false;
                break;
            case State.MATCH:
                this.scheduleOnce(() => {
                    const anim = this.skeleton.animation === 'anti2' ? 'match2' : 'match1';
                    this.skeleton.setAnimation(0, anim, false);
                }, Math.random() * 0.5);
                break;
            case State.THUNDER:
                this.skeleton.node.active = true;
                this.skeleton.setAnimation(0, 'lightning', false);
                this.skeleton.timeScale = 1.1;
                // this.isSpecial = false;
                break;
            case State.REMOVE:
                break;
            case State.OVERRIDE:
                break;
            case State.INFO:
                this.playInfo();
                break;
        }
        this.state = state;
    },
});
